<template>
  <div class="modal fade" :id="id" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" :class="dialogClass" role="document" :style="`width:${dialogWidth};`">
      <div class="modal-content" :class="contentClass">
        <slot v-if="!hideHeader" name="header">
          <div class="modal-header">
            <h3 class="modal-title font-weight-bold text-dark">{{ title }}</h3>
            <a
              v-if="!hideClose"
              class="icon icon-remove text-right text-dark"
              @click.prevent="$emit('close')"
              data-dismiss="modal"
              aria-label="Close"
            ></a>
          </div>
        </slot>

        <slot name="body">
          <div class="modal-body">
            <p>Modal body text goes here.</p>
          </div>
        </slot>

        <slot v-if="!hideFooter" name="footer">
          <div class="modal-footer">
            <a class="btn btn-secondary" @click.prevent="$emit('close')" data-dismiss="modal">Close</a>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    contentClass: { type: String, required: false },
    dialogClass: { type: String, required: false },
    hideClose: { type: Boolean, default: false },
    hideFooter: { type: Boolean, default: false },
    hideHeader: { type: Boolean, default: false },
    id: { type: String, required: true },
    title: { type: String, required: false },
    width: { type: Number }
  },
  computed: {
    dialogWidth() {
      if (!!this.width) {
        return `${this.width}px`;
      } else {
        return "100%";
      }
    }
  }
};
</script>
